module.exports = __webpack_public_path__ + "58fcf8507cb40547b690a68158c8c759.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/purasalud.png
// module id = 619
// module chunks = 0